module.exports = __webpack_public_path__ + "static/media/CheckBox.794273e7.svg";